import { useContext, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import Brand from '../Brand/Brand';
import Navigation, { NavigationLine } from '../Navigation/Navigation';
import User from '../User/User';
import { commonsMenu, usersMenu, demoPages } from '../../menu';
import ThemeContext from '../../contexts/themeContext';
import LANG, { getLangWithKey } from '../../lang';
import Icon from '../../components/icon/Icon';
import Button from '../../components/bootstrap/Button';
import Tooltips from '../../components/bootstrap/Tooltips';
import useDarkMode from '../../hooks/useDarkMode';
import useAsideTouch from '../../hooks/useAsideTouch';
import { useMst } from '../../models';
import CompanyService from '../../services/CompanyService';
import { getItem } from '../../lib/localstorage';
import { getRoleFilteredMenu, isPermittedPage } from '../../utils/role.utils';
import { useChangeLanguage } from '../../helpers/locales';

const CLOSE_BTN_STYLE = { left: '15rem', background: '#F6F6F6', width: '40px', height: '80px', borderRadius: '0 8px 8px 0' };

const Aside = observer(() => {
	const { updateLanguage } = useChangeLanguage();
	const { asideStatus, setAsideStatus, asideSubStatus, setAsideSubStatus, asideSubMenuStatus, asideMenu, mobileDesign, lang, setLang, noticeCount } = useContext(ThemeContext);
	const { asideStyle, asideSubStyle, touchStatus, hasTouchButton, asideWidthWithSpace, asideSubWidthWithSpace, x, x2 } = useAsideTouch();
	const isModernDesign = process.env.REACT_APP_MODERN_DESGIN === 'true';
	const constraintsRef = useRef(null);

	const [doc, setDoc] = useState(false);

	const { t, i18n } = useTranslation();
	const { darkModeStatus,setDarkModeStatus } = useDarkMode();
	const { user, company, navtabmenus } = useMst();
	const navigation = useNavigate();
	const location = useLocation()

	const styledBtn = {
		color: darkModeStatus ? 'dark' : 'light',
		hoverShadow: 'default',
		isLight: !darkModeStatus,
		size: 'lg',
	};

	const cleaerRestInfo = async () => {
		await company.setRestInfo({})
	}
	const setRestInfo = async () => {
		try {
			const res = await CompanyService.restdayInfo({ companyId: company.id, userId: user.id });
			if (res?.data) await company.setRestInfo(res.data);
		} catch (e) {
			console.error(e);
		}
	};

	const changeLanguage = (lng) => {
		updateLanguage(lng);
	};

	useEffect(() => {
		const navTabls = JSON.parse(getItem(`navTabMenu_${company.get.id}_${company.get.isDoc ? 'admin':'user'}`) || JSON.stringify([]));

		if(navtabmenus?.setMenus)
			navtabmenus?.setMenus(navTabls);

		if (company.get.isDoc) {

			cleaerRestInfo();
		} else {

			setRestInfo();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [company.get.isDoc, navtabmenus]);

	useEffect(() => {
		if (mobileDesign && asideStatus) {
			setAsideStatus(false);
			setAsideSubStatus(false);
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location.pathname]);

	useEffect(() => {
		if (!(user.me?.id > 0) || !user.me.permissions?.menuRole) return;

		const notFoundPath = `/${demoPages.page404.path}`;
		if (!isPermittedPage(user.me.permissions?.menuRole, location.pathname, user.me.permissions?.userMenuRole)) {
			if (location.pathname !== notFoundPath) {
				navigation(notFoundPath, { replace: true });
			}
		} else if (location.pathname === '/e-approval/setting/outOfOffice' && !(user.me.permissions?.detailRole?.approval?.absentee)) {
			// 부재설정 기능은 권한관리의 detailRole에 속해 있어서, 전체적인 page Layout Aside.js 에서 판단하는것이 아니라 이곳에다가 따로 path를 부여하는식으로 체크 했습니다.
			// alert('접근 권한이 없는 페이지 입니다.')

			// navigation(-1)
		}
	}, [location.pathname, navigation, user.me?.id, user.me.permissions?.menuRole, user.me.permissions?.userMenuRole, user.me.permissions?.detailRole?.approval?.absentee])

	return (
		<>
			<motion.aside
				style={{
					...asideStyle,
					...(mobileDesign && !asideStatus
						? { left: `calc(-${process.env.REACT_APP_ASIDE_WIDTH_PX}px - 1rem)`, transition: 'left 0.3s ease' }
						: {}),
				}}
				className={classNames(
					'aside',
					{ open: asideStatus },
					{
						'aside-touch-bar': hasTouchButton && isModernDesign,
						'aside-touch-bar-close': !touchStatus && hasTouchButton && isModernDesign,
						'aside-touch-bar-open': touchStatus && hasTouchButton && isModernDesign,
					}
				)}>
				{/* [mo] aside 위에 바로 로고 */}
				{mobileDesign && (
					<div className='aside-head'>
						<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} asideSubStatus={asideSubStatus} setAsideSubStatus={setAsideSubStatus} />
					</div>
				)}

				{/* [pc, mo] 이름 상단에 위치 */}
				<div className='user_box'><User/></div>

				{/* [pc] aside 크기 제어 버튼 */}
				{!mobileDesign && (
					<Brand asideStatus={asideStatus} setAsideStatus={setAsideStatus} asideSubStatus={asideSubStatus} setAsideSubStatus={setAsideSubStatus} hasLogo={false} />
				)}

				<div className={`aside-body ${company.get.isAdmin ? 'admin_body' : 'user_body'}`}>
					{!mobileDesign && !company.get.isAdmin && (
						<NavigationLine />
					)}
					{company.get.isAdmin && !mobileDesign &&
						<>
							<NavigationLine className='toggle-line-top' />
							<div className='navigation-item toggle_mode'>
								<div
									className='navigation-link cursor-pointer'
									onClick={() => {
										const nextIsAdmin = !company.get.isDoc;
										company.setIsAdmin(nextIsAdmin);
										// 모드에 따라 대시보드 이동
										navigation(nextIsAdmin ? '/adminDashboardNew' : '/home');
									}}
								>
									<span className='navigation-link-info'>
									<Icon icon={company.get.isDoc ? 'ToggleOn' : 'ToggleOff'} color={company.get.isDoc ? 'success' : 'info'} size='2x' className='navigation-icon'/>
									<span className='navigation-text fw-bold'>{company.get.isDoc ? t('common.label.adminMode') : t('common.label.userMode')}</span>
									</span>
								</div>
							</div>

							<NavigationLine className='toggle-line-bottom' />
						</>
					}

					<Navigation menu={commonsMenu} id='aside-dashboard' />
					{/*  사용자 전용 메뉴 */}
					{!company.get.isDoc && (
						<>
							<Navigation menu={(!company.get.isAdmin && (user.me.workGubun === '기능직' || user.me.workGubun === '현장직'))
								? Object.values(usersMenu).filter(menu => menu.id !== 'approvalDocument') : getRoleFilteredMenu(user.me, 'user') } id='aside-menu-two' />

						</>
					)}
					{/*  관리자 전용 메뉴 */}
					{company.get.isDoc && (
						<>
							<Navigation menu={getRoleFilteredMenu(user.me, 'admin')} id='aside-menu-two' />
						</>
					)}
				</div>
				{/* Aside 닫기 버튼(모바일) */}
				{
					(asideStatus && mobileDesign) &&
					<div
						className='position-absolute'
						style={CLOSE_BTN_STYLE}
					>
						<Button
							type='button'
							aria-label='Toggle Aside'
							className='w-100 h-100 p-0'
							onClick={() => {
								setAsideStatus(!asideStatus);
								setAsideSubStatus(!asideSubStatus);
							}}>
							<Icon icon='FirstPage' size='3x' />
						</Button>
					</div>
				}
			</motion.aside>

			{/* SUB */}
			{asideSubMenuStatus && (
				<motion.asides
					style={asideSubStyle}
					className={classNames(
						'aside-sub',
						//{ 'd-none': !asideSubStatus && hasTouchButton && isModernDesign },
						{ open: asideSubStatus },
						{
							'aside-touch-bar': hasTouchButton && isModernDesign,
							'aside-touch-bar-close': !touchStatus && hasTouchButton && isModernDesign,
							'aside-touch-bar-open': touchStatus && hasTouchButton && isModernDesign,
						}
					)}>
					<div className='aside-sub-head'></div>
					<div className='aside-sub-body'>
						<Navigation menu={asideMenu} id='aside-sub-dashboard' />
					</div>
					<div className='aside-sub-foot'></div>
				</motion.asides>
			)}

			{asideStatus && hasTouchButton && isModernDesign && (
				<>
					<motion.div className='aside-drag-area' ref={constraintsRef} />
					<Tooltips title={t('Toggle Aside')} flip={['top', 'right']}>
						<motion.div
							className='aside-touch'
							drag='x'
							whileDrag={{ scale: 1.2 }}
							whileHover={{ scale: 1.1 }}
							dragConstraints={constraintsRef}

							dragElastic={0.1}
							style={{ x, zIndex: 1039 }}
							onClick={() => {
								x.set(x.get() === 0 ? asideWidthWithSpace : 0);
								x2.set(x2.get() === 0 ? asideSubWidthWithSpace : 0);
							}}
						/>
					</Tooltips>
				</>
			)}
		</>
	);
});

export default Aside;
